"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButtonGrid = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Generates a grid of radio buttons arranged in the specified number of columns.
 *
 * Props:
 * name: name used to group radio buttons
 * radioBtns:  array of button objects for filtering ({ label: <string>, value: <string> })
 * numColumns: Integer -- number of columns in which to display the radio buttons
 * radioSelectedValue: selected value for search radio group
 * handleRadioSelection:  handler for search radio button changes
 */
var RadioButtonGrid = function RadioButtonGrid(_ref) {
  var name = _ref.name,
    radioButtons = _ref.radioButtons,
    numColumns = _ref.numColumns,
    radioSelectedValue = _ref.radioSelectedValue,
    handleRadioSelection = _ref.handleRadioSelection;
  function singleRadioBtn(btn, numColumns, idx) {
    if (numColumns > 16) return null;
    return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
      key: "singleRadio-".concat(btn.title, "-").concat(idx),
      width: Math.floor(16 / numColumns)
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Radio, {
      title: "Search By ".concat(btn.label),
      label: btn.label,
      name: name,
      value: btn.value,
      disabled: btn.disabled,
      checked: radioSelectedValue === btn.value,
      onChange: handleRadioSelection,
      "aria-labelledby": "searchLabel"
    }));
  }
  function radioButtonRow(arrayChunk, numColumns, idx) {
    return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, {
      key: "radioButtonRow-".concat(idx),
      columns: numColumns,
      className: "radio-grid-row"
    }, arrayChunk.map(function (btn, idx) {
      return singleRadioBtn(btn, numColumns, idx);
    }));
  }
  // a single radio button doesn't make sense, return null
  if (radioButtons.length < 2) return null;
  return _lodash.default.chunk(radioButtons, numColumns).map(function (chunk, idx) {
    return radioButtonRow(chunk, numColumns, idx);
  });
};
exports.RadioButtonGrid = RadioButtonGrid;